import { render, staticRenderFns } from "./YzAddressInput.vue?vue&type=template&id=518d73d6&scoped=true&lang=pug&"
import script from "./YzAddressInput.vue?vue&type=script&lang=js&"
export * from "./YzAddressInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d73d6",
  null
  
)

/* custom blocks */
import block0 from "./YzAddressInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports